// removed by extract-text-webpack-plugin
module.exports = {"AdminPickup":"AdminPickup__AdminPickup__3dJnl"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/AdminPickup/AdminPickup.css
// module id = 261
// module chunks = 1